import React from 'react';
import '../../assets/css/shimmer.css'

const LoderBlogIso = () => {

    return (
        <div className='portfolio-iso'>
            <div id="filters" className="gallery-filters filters position-relative">
                <button className="item item-button  d-inline-block active shimmerBox" data-filter="*">
                    <span className="d-inline-block text-center"><div className="shine d-block shimmerLine"></div></span>
                </button>
                <button className="item item-button  d-inline-block shimmerBox" data-filter=".iso1">
                    <span className="d-inline-block text-center"><div className="shine d-block shimmerLine"></div></span>
                </button>
                <button className="item item-button  d-inline-block shimmerBox" data-filter=".iso2">
                    <span className="d-inline-block text-center"><div className="shine d-block shimmerLine"></div></span>
                </button>
            </div>
            <div className="product-list-box mt-3 mt-sm-0">
                <div className='row'>
                    <div className="col-sm-6 col-xl-4">
                        <div className="position-relative overflow-hidden shimmerBox">
                            <div className="item-img">
                                <div className="shine shimmerBoxIn"></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <div className="position-relative overflow-hidden shimmerBox">
                            <div className="item-img">
                                <div className="shine shimmerBoxIn"></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <div className="position-relative overflow-hidden shimmerBox">
                            <div className="item-img">
                                <div className="shine shimmerBoxIn"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default LoderBlogIso;